export const CheckCircleIcon = () => (
  <span
    className="uil uil-check-circle"
    style={{ color: "#E80537", fontSize: 20 }}
  />
);